import { render } from "./App.vue?vue&type=template&id=8aae99ec"
const script = {}

import "./App.vue?vue&type=style&index=0&id=8aae99ec&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__